
import { Options, Vue, prop } from "vue-class-component";
import Skeleton from "@/app/ui/components/skeleton/index.vue";
import Icons from "@/app/ui/components/icons/index.vue";
import Card from "@/app/ui/components/card/index.vue";
import { formatCompactNumber as fmtCompact, formatByCountry } from "@/app/infrastructures/misc/Utils";
import { PickupDashboardController } from "@/app/ui/controllers/PickupDashboardController";

interface SummaryStatusData {
  seller?: number;
  courier?: number;
  shipment?: number;
  quantity?: number;
}

class Props {
  crrotw = prop<SummaryStatusData>({
    default: () => ({}),
    type: Object
  });
  crrpic = prop<SummaryStatusData>({
    default: () => ({}),
    type: Object
  });
  crrdon = prop<SummaryStatusData>({
    default: () => ({}),
    type: Object
  });
  isLoading = prop<boolean>({
    default: false,
    type: Boolean
  });
}

@Options({
  components: {
    Skeleton,
    Icons,
    Card
  }
})
export default class SummaryCourierPickup extends Vue.with(Props) {
  get isExpanded() {
    return PickupDashboardController.isSumaryDetailExpanded;
  }

  setIsExpanded(val: boolean) {
    PickupDashboardController.setIsSumaryDetailExpanded(val);
  }

  get statusMaps() {
    return {
      CRROTW: { title: this.$t("pickupDashboard.belumDiPickUp"), icon: "ics_o_package-crrotw" },
      CRRPIC: { title: this.$t("pickupDashboard.belumDisetor"), icon: "ics_o_package-crrpic" },
      CRRDON: { title: this.$t("pickupDashboard.belumBkd"), icon: "ics_o_package-crrdon" }
    };
  }

  get totalShipment() {
    return (
      (this.crrotw.shipment || 0) +
      (this.crrpic.shipment || 0) +
      (this.crrdon.shipment || 0)
    );
  }

  get totalQuantity() {
    return (
      (this.crrotw.quantity || 0) +
      (this.crrpic.quantity || 0) +
      (this.crrdon.quantity || 0)
    );
  }

  formatCompactNumber(val: number) {
    return fmtCompact(val);
  }

  formatNumber(val: number) {
    return formatByCountry(val, { type: "quantity" });
  }

  get cards() {
    return [
      {
        status: "CRROTW",
        mainValue: this.crrotw.seller || 0,
        mainLabel: this.$t("pickupDashboard.sender"),
        subValue: this.crrotw.shipment || 0,
        subLabel: this.$t("pickupDashboard.package")
      },
      {
        status: "CRRPIC",
        mainValue: this.crrpic.shipment || 0,
        mainLabel: this.$t("pickupDashboard.package"),
        subValue: this.crrpic.quantity || 0,
        subLabel: this.$t("pickupDashboard.koli")
      },
      {
        status: "CRRDON",
        mainValue: this.crrdon.shipment || 0,
        mainLabel: this.$t("pickupDashboard.package"),
        subValue: this.crrdon.quantity || 0,
        subLabel: this.$t("pickupDashboard.koli")
      }
    ];
  }
}
